import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MobileStickyCTA = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 sm:hidden">
      <Link 
        to="/request-placement"
        className="w-full block text-center rounded-2xl px-5 py-3 font-semibold text-white"
        style={{ background: 'linear-gradient(90deg, #06b6d4, #3b82f6, #6366f1)' }}
      >
        {t('hero.cta_primary')}
      </Link>
    </div>
  );
};

export default MobileStickyCTA;
